import React from 'react'
import NextLink from 'next/link'
import { Row, Col, Tag } from 'antd'
import PropTypes from 'prop-types'

export default function ArticleTags({
  categories,
  broker,
  software,
  page = null,
}) {
  return (
    <Row gutter={[0, 16]} style={{ marginBottom: 0 }}>
      <Col span={23}>
        {categories ? (
          <>
            {page === 'article' ? 'Categories: ' : null}
            {categories.map((category, i) => (
              <NextLink
                key={i}
                href="/faqs/[slug]/"
                as={`/faqs/${category.attributes.slug}/`}
              >
                <Tag key={i} color={broker ? '#55acee' : '#3b5999'}>
                  {category.attributes.name}
                </Tag>
              </NextLink>
            ))}
          </>
        ) : null}
        {broker ? (
          <NextLink
            href="/broker/[slug]"
            as={`/broker/${broker.attributes.slug}`}
          >
            <Tag color="#3b5999"> {broker.attributes.name}</Tag>
          </NextLink>
        ) : null}
        {software ? (
          <NextLink
            href="/software/[slug]"
            as={`/software/${software.attributes.slug}`}
          >
            <Tag color="#cd201f">{software.attributes.name}</Tag>
          </NextLink>
        ) : null}
      </Col>
    </Row>
  )
}

ArticleTags.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ),
  broker: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }),
  software: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }),
}
